export class FAQ {

    public key: string = null;
    public a: string = null;
    public q: string = null;
    public category: string = null;
    public createdBy: string = null;
    public createdOn: any = "";
    public link: string = "";
    public linkText: string = "";
    public externalLink: boolean = false;

    constructor(key: string, json: any = null) {
        this.key = key;
        if(json) this.updateFromJson(json);
    }

    public updateFromJson(json: any) {
        console.log(json);
        this.q = json.q || "";
        this.a = json.a || "";
        this.category = json.category || "";
        this.createdBy = json.createdBy || "";
        this.createdOn = json.createdOn || 0;
        this.link = json.link || "";
        this.linkText = json.linkText || "";
        this.externalLink = json.externalLink || false;
    }

    public toJson() {
        return {
            q: this.q,
            a: this.a,
            category: this.category,
            createdBy: this.createdBy,
            createdOn: this.createdOn,
            link: this.link,
            linkText: this.linkText,
            externalLink: this.externalLink
        }
    }
}
